import styled from 'astroturf/react';
import trackClick from 'js/utils/trackClick';
import { Work } from './types';

type PaperThumbnailProps = {
  work: Work;
  paperType: string;
  width?: number;
  height?: number;
};

const ThumbWrap = styled.a`
  flex-shrink: 0;
  border: 1px solid var(--stroke-light, #dddde2);
  overflow: hidden;
  background: var(--background-white, #fff);
`;

const ThumbImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const PaperThumbnail: React.FunctionComponent<PaperThumbnailProps> = ({
  work,
  paperType,
  width = 60,
  height = 88,
}) => {
  return (
    <ThumbWrap
      style={{ width: `${width}px`, height: `${height}px` }}
      href={work.url}
      onClick={() => {
        trackClick({
          source: 'single_claim_page.paper_thumbnail_click',
          entityId: work.id,
          extra: {
            paper_type: paperType,
          },
        });
      }}
    >
      <ThumbImg src={work.small_thumbnail_url} alt="" />
    </ThumbWrap>
  );
};

export default PaperThumbnail;
